import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { BasketService } from 'src/app/services/basket.service';
import { DataService } from 'src/app/services/data.service';
import { OrderService } from 'src/app/services/order.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { Drink } from 'src/interfaces/drink.model';
import { Food } from 'src/interfaces/food.model';
import { Locale } from 'src/interfaces/locale.model';
import { Order } from 'src/interfaces/order.model';
import { MenuOrderDialogComponent } from '../menu-order-dialog/menu-order-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-menu-order',
    templateUrl: './menu-order.component.html',
    styleUrls: ['./menu-order.component.css'],
    standalone: false
})
export class MenuOrderComponent {
  constructor(
    private dataService: DataService,
    private orderService: OrderService,
    private basketService: BasketService,
    private scrollService: ScrollService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.locale = this.dataService.locale;
    this.guestId = this.dataService.guestId;
  }


  order: Order | null = null;
  locale: Locale | null = null;
  basketFoods: Food[] = [];
  basketDrinks: Drink[] = [];
  guestId: string;
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    // console.log('MenuOrderComponent | ngOnInit() | guestId:', this.guestId);
    this.orderService.subscribeToOrder()
      .pipe(takeUntil(this.destroy$))
      .subscribe(order => {
          this.order = order;
          if (order) {
            // console.log('MenuOrderComponent | ngOnInit() | order:', JSON.stringify(order, null, 2));
          }
      });

    // Basket foods
    this.basketService.foods
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Food[]) => {
        this.basketFoods = data;
        // console.log('MenuOrderComponent | ngOnInit() | foods:', this.foods.map(x => x.title).join(', '));
      });

    // Basket drinks
    this.basketService.drinks
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Drink[]) => {
        this.basketDrinks = data;
        // console.log('MenuOrderComponent | ngOnInit() | foods:', this.drinks.map(x => x.title).join(', '));
      });
  }


  onOrderClicked(): void {
    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');
    this.scrollService.setScrollEnabled(false);

    const dialogRef = this.dialog.open(MenuOrderDialogComponent, sheetDialogConfig());

    dialogRef.afterClosed().subscribe(result => {
      this.scrollService.setScrollEnabled(true);

      if (!result) {
        console.info('MenuOrderComponent | afterClosed() | Dialog closed without result');
      }

      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#f5f5ff');
    });
  }

  ngOnDestroy(): void {
    // Очистка подписки
    this.destroy$.next();
    this.destroy$.complete();
    console.log('MenuOrderComponent | ngOnDestroy() | subscription cancelled');
  }
}
